import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faCamera, faUser } from '@fortawesome/free-solid-svg-icons'
import { MAX_PHOTO_MB, PHOTO_ACCEPT, isFileTooBig } from '../marketplaceConstants'

const ProfilePhotoPicker = ({ file, onChange, isCompany, error }) => {
  const inputRef = useRef()
  const [preview, setPreview] = useState(null)
  const [sizeError, setSizeError] = useState(null)

  useEffect(() => {
    if (!file) {
      setPreview(null)
      return undefined
    }
    const url = URL.createObjectURL(file)
    setPreview(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  const shownError = sizeError || error

  return (
    <div className="d-flex align-items-center mb-4">
      <button
        type="button"
        onClick={() => inputRef.current.click()}
        className={classNames('flex-shrink-0 d-flex align-items-center justify-content-center border overflow-hidden p-0', {
          'rounded-circle': !isCompany,
          rounded: isCompany,
          'border-danger': shownError
        })}
        style={{ width: 96, height: 96, backgroundColor: '#f9fafd', borderStyle: 'dashed', borderWidth: 2 }}
        title={isCompany ? 'Subir logo' : 'Subir foto'}
      >
        {preview ? (
          <img src={preview} alt="" style={{ width: '100%', height: '100%', objectFit: isCompany ? 'contain' : 'cover' }} />
        ) : (
          <FontAwesomeIcon icon={isCompany ? faBuilding : faUser} size="2x" className="text-400" />
        )}
      </button>
      <div className="ml-3">
        <p className="mb-1 font-weight-semi-bold">
          {isCompany ? 'Logo de la empresa' : 'Foto de perfil'}
          <span className="text-danger ml-1">*</span>
        </p>
        <p className="mb-2 fs--1 text-600">
          {isCompany
            ? 'Es lo primero que verán los propietarios en tus servicios.'
            : 'Una foto de tu rostro, de frente y con buena luz. Genera confianza en los propietarios.'}
        </p>
        <button type="button" className="btn btn-falcon-default btn-sm" onClick={() => inputRef.current.click()}>
          <FontAwesomeIcon icon={faCamera} className="mr-1" />
          {file ? 'Cambiar' : 'Elegir imagen'}
        </button>
        {shownError && <small className="text-danger d-block mt-1">{shownError}</small>}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={PHOTO_ACCEPT}
        className="d-none"
        onChange={({ target }) => {
          const selected = target.files?.[0]
          target.value = ''
          if (!selected) return
          if (isFileTooBig(selected, MAX_PHOTO_MB)) {
            setSizeError(`La imagen pesa más de ${MAX_PHOTO_MB} MB.`)
            return
          }
          setSizeError(null)
          onChange(selected)
        }}
      />
    </div>
  )
}

export default ProfilePhotoPicker
